import {bindActionCreators, Dispatch} from 'redux';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { RootState } from '../../reducers';
import * as actions from '../../actions/generalActions';
import { withRouter } from 'react-router';
import './Production.scss'
import { Redirect, Route, Switch } from 'react-router-dom';
import CreateProductionsForm from './CreateProductionsFrom';
import ResponsibilitySlider from './ResponsibilitySlider';
import CalendarComponent from '../../components/Calendar/CalendarComponent';
import React, {useEffect} from "react";
import Archive from "../Archive/Archive";
import ArchivedProductsPage from "./ArchivedProductsPage";
import ArchivedResponsibilitiesPage from "./ArchivedResponsibilitiesPage";
import Page404 from "../Page404";
import PassiveProductsPage from "./PassiveProductsPage";
import ReworkHistoryPage from "./ReworkHistoryPage";
import ProductionProductsPage from "./ProductionProductsPage";
import CreateProductionsFrom from "./CreateProductionsFrom";
import ProductionRapport from "./ProductionRapport";
import WorkerDashboard from "./WorkerDashboard";
import NewProductionBoard from "./NewBoard/NewProductionBoard";
import NewArchiveBoard from "./NewBoard/NewArchiveBoard";

interface Props {
    actions: any
}

const Production = (props: Props) => {

    useEffect(()=>{
        props.actions.getUserPermissionsAndResponsibilities()
    }, [])

    return(
        <div className="h-100">
            <Switch>
                <Route exact path="/dashboard/production" render={() => <Redirect to="/dashboard/production/board" />} />
                <Route exact path="/dashboard/production/board" component={NewProductionBoard} />
                <Route exact path="/dashboard/production/create/:clientId?" render={()=> <CreateProductionsFrom doneStatus={0}/> }/>
                <Route exact path="/dashboard/production/archive/:clientId?" component={NewArchiveBoard}/>
                <Route exact path="/dashboard/production/archive-old/:clientId?" render={()=> <CreateProductionsFrom doneStatus={1}/> }/>
                <Route exact path="/dashboard/production/my-tasks" component={WorkerDashboard}/>
                <Route exact path="/dashboard/production/production-rapport" component={ProductionRapport}/>
                <Route exact path="/dashboard/production/products" component={ProductionProductsPage}/>
                <Route exact path="/dashboard/production/userAssignment" component={ResponsibilitySlider}/>
                <Route exact path="/dashboard/production/calendar" render={()=> <CalendarComponent/> }/>
                <Route path="/dashboard/production/archive/:moduleName?" component={Archive} />
                <Route path="/dashboard/production/archived-products" component={ArchivedProductsPage} />
                <Route path="/dashboard/production/archived-responsibilities" component={ArchivedResponsibilitiesPage} />
                <Route path="/dashboard/production/returned-processes" component={ReworkHistoryPage} />
                <Route path="/dashboard/production/passive-products" component={PassiveProductsPage} />
                <Route render={()=><Page404/>}/>
            </Switch>
        </div>
    )
}

function mapStateToProps(state: RootState, ownProps: any) {
    return {
        ...ownProps,
        ...state.app,
        agreements: state.agreements
    }
}

function mapDispatchToProps(dispatch: Dispatch<actions.ACTION>) {
    return {
        actions: bindActionCreators(actions as any, dispatch)
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(injectIntl(Production as any)));